/* ニュースを探す（sections/tds-news-finder.liquid。2026-10-01）
   - 種類のタブ（ニュース／コラム／セミナー・ウェビナー）をその場で切り替える。左の絞り込み・一覧・下のボタンは、
     種類ごとにサーバーが描いた欄をまるごと入れ替えるだけ（JS は中身を作らない）。JS が無いときはタブがページへのリンクとして働く
   - タブの列は追従する（position:sticky）。追従ヘッダーの下で止まるよう、その高さを --tnf-sticky-top に入れる
   - 追従中に切り替えたら、タブの列の元の位置まで戻す（新しい一覧を先頭から見せる） */
(() => {
  if (window.tdsNewsFinder) return;
  window.tdsNewsFinder = true;
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 追従ヘッダー（いま画面上端を覆っている fixed / sticky の要素）の下端
  const headerBottom = () => {
    let found = 0;
    document.querySelectorAll('header, .tds-header, [class*="header"]').forEach((element) => {
      const style = getComputedStyle(element);
      if (style.position !== 'fixed' && style.position !== 'sticky') return;
      const box = element.getBoundingClientRect();
      if (box.height && box.top <= 1 && box.bottom > 1) found = Math.max(found, box.bottom);
    });
    return Math.min(found, 160);
  };
  let frame = 0;
  let stickyTop = null;
  const syncStickyTop = () => {
    frame = 0;
    const value = Math.round(headerBottom());
    if (value === stickyTop) return;
    stickyTop = value;
    document.documentElement.style.setProperty('--tnf-sticky-top', `${value}px`);
  };
  const requestSync = () => { if (!frame) frame = requestAnimationFrame(syncStickyTop); };

  const init = (root) => {
    if (root.dataset.tnfReady) return;
    const list = root.querySelector('[data-tnf-tabs]');
    const tabs = list ? [...list.querySelectorAll('[data-tnf-tab]')] : [];
    if (tabs.length < 2) return;
    root.dataset.tnfReady = 'true';
    const panelOf = (tab) => document.getElementById(tab.getAttribute('aria-controls'));
    // タブの列の元の位置（追従していないときの上端）。追従中は列そのものでは測れないので、直前の見出しの下端から出す
    const header = list.previousElementSibling;
    const originalTop = () => {
      if (!header) return list.getBoundingClientRect().top + window.scrollY;
      return header.getBoundingClientRect().bottom + (parseFloat(getComputedStyle(header).marginBottom) || 0) + window.scrollY;
    };

    const select = (tab, { focus = false } = {}) => {
      if (tab.getAttribute('aria-selected') === 'true') return;
      // 追従中（列の元の位置より下を見ている）なら、切り替えたあと列の元の位置へ戻す
      const top = Math.max(0, Math.round(originalTop() - (stickyTop || 0)));
      const stuck = window.scrollY > top + 1;
      tabs.forEach((other) => {
        const on = other === tab;
        other.setAttribute('aria-selected', String(on));
        other.tabIndex = on ? 0 : -1;
        const panel = panelOf(other);
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus({ preventScroll: true });
      if (stuck) {
        try { window.scrollTo({ top, behavior: reduceMotion() ? 'auto' : 'smooth' }); } catch (error) { window.scrollTo(0, top); }
      }
    };

    list.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-tnf-tab]');
      if (!tab || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; // 新しいタブで開くのは妨げない
      event.preventDefault();
      select(tab);
    });
    list.addEventListener('keydown', (event) => {
      const index = tabs.indexOf(document.activeElement);
      if (index < 0) return;
      let next = null;
      if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
      else if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
      else if (event.key === 'Home') next = tabs[0];
      else if (event.key === 'End') next = tabs[tabs.length - 1];
      else if (event.key === ' ') next = tabs[index];
      if (!next) return;
      event.preventDefault();
      select(next, { focus: true });
      next.focus({ preventScroll: true });
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-tnf]').forEach(init);
    syncStickyTop();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('scroll', requestSync, { passive: true });
  window.addEventListener('resize', requestSync);
  document.addEventListener('shopify:section:load', boot);
})();
